import React from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

type Props = Readonly<{
  onReconnect: () => void
}>

export function IdleBanner({ onReconnect }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="idle-timer-banner">
      <div className="inner">
        <p className="heading">{t('You have been idle for a while')}</p>
        <p>{t('Click reconnect to continue')}</p>
        <button onClick={onReconnect} type="button">
          {t('Reconnect')}
        </button>
      </div>
    </div>
  )
}
